<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="cablesMain">
          <project-asset
            v-on:project-changed="onProjectChange"
            v-on:vessel-changed="onVesselChange"
          ></project-asset>
          <v-card id="cablesCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.cables') }}</v-card-title
            >
            <v-data-table
              id="cablesTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              :sort-by="['cableID']"
              :sort-desc="[false]"
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: right">{{ props.item.cableID }}</td>
                  <td style="text-align: left">{{ props.item.projectName }}</td>
                  <td style="text-align: left">{{ props.item.vesselName }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: left">{{ props.item.type }}</td>
                  <td style="text-align: right">{{ props.item.totalLength | formatTNumber }}</td>
                  <td style="text-align: left">{{ props.item.lineName }}</td>
                  
                  <td>
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">
                        mdi-delete
                      </v-icon> </v-btn
                    >&nbsp;
                    <v-btn
                      id="btnEdit"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.isDeleted === true"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="showDialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.cableID"
                          :rules="[
                            () => !!editedItem.cableID || requiredMessage
                          ]"
                          required
                          :readonly="this.editedIndex > 0"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('nav.cableId') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.lineId || requiredMessage
                          ]"
                          required
                          :items="lines"
                          item-text="lineCode"
                          item-value="id"
                          v-model="editedItem.lineId"
                          >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('vesselActivities.lines') }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.projectId || requiredMessage
                          ]"
                          required
                          :items="projects"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.projectId"
                          :readonly="editedIndex != -1"
                          @change="onDlgProjectChange"
                          >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('common.projectName') }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.vesselId || requiredMessage
                          ]"
                          required
                          class="form-control"
                          :items="projectVessels"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.vesselId"
                          :readonly="editedIndex != -1"
                          @change="onDlgVesselChange"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('nav.vessels') }}
                          </template>
                        </v-select></v-col
                      >
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.description"
                          :rules="[
                            () => !!editedItem.description || requiredMessage
                          ]"
                          required
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('column.description') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.type">
                          <template v-slot:label>
                            {{ $t('column.type') }}
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <positive-numeric-input
                          v-model="editedItem.totalLength"
                          label="cables.tcl"
                          thousands-separator
                        >
                        </positive-numeric-input>
                      </v-col>
                    </v-row>
                  </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{
                    $t('common.cancel')
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="save"
                    :disabled="!formIsValid"
                    >{{ $t('common.save') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn
                  id="btnAddcables"
                  color="primary"
                  dark
                  small
                  left
                  fab
                  @click="createItem()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import ProjectAsset from '../common/ProjectAsset'

export default {
  components: {
    'project-asset': ProjectAsset
  },
  data() {
    return {
      showDialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
        { text: this.$t('nav.cableId'), align: 'right', sortable: true, value: 'cableID' },
        { text: this.$t('common.projectName'), align: 'left', value: 'projectId' },
        { text: this.$t('common.asset'), align: 'left', value: 'vesselId' },
        { text: this.$t('column.description'), align: 'left', value: 'description' },
        { text: this.$t('column.type'), align: 'left', value: 'type' },
        { text: this.$t('cables.tcl'), align: 'right', value: 'totalLength' },
        { text: this.$t('vesselActivities.lines'), align: 'left', value: 'lineName' },
        { text: this.$t('column.actions'), align: 'center', value: 'cablesactions', sortable: false }
      ],

      editedIndex: -1,
      editedItem: {},
      defaultItem: { totalLength: null },

      selProjectId: 0,
      selVesselId: 0, 
      selLineId: 0,
      dlgSelProjectId: null
    }
  },
  computed: {
    ...mapGetters([
      'm_cable/getNextSeqCode',
      'm_cable/getCables',
      'm_cable/getLines',

      'm_project/getProjectNames',
      'm_project/getProjectVesselIds',

      'm_vessel/getVesselNames',

      'm_passet/getSelProjectId',
      'm_passet/getSelVesselId',
      'm_passet/getSelProjectVesselIds'
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.cable')
        : this.$t('common.edit') + ' ' + this.$t('nav.cable')
    },
    items() {
      return this['m_cable/getCables']
    },

    projects() {
      return this['m_project/getProjectNames'].filter((p) => p.VCount > 0)
    },

    vessels() {
      return this['m_vessel/getVesselNames']
    },

    projectVessels() {
      let vessels = this.vessels

      let pvIds = this['m_passet/getSelProjectVesselIds']
      if (this.dlgSelProjectId) {
        pvIds = this['m_project/getProjectVesselIds']
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1)
    },

    lines() {
      return this["m_cable/getLines"];
    },

    formIsValid() {
      return (
        this.editedItem.cableID &&
        this.editedItem.description &&
        this.editedItem.projectId &&
        this.editedItem.vesselId
      )
    }
  },
  watch: {
    showDialog(val) {
      val || this.close()
    }
  },

  created() {
    this.selProjectId = this['m_passet/getSelProjectId']
    this.selVesselId = this['m_passet/getSelVesselId']

    this.$log.debug('loading cables for', this.selProjectId, this.selVesselId)
    this.refreshCables()
    this.refreshLines()
    this.refreshNextSeqCode()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader()
    })
  },
  methods: {
    ...mapMutations(['mHideLongLoader']),
    ...mapActions([
      'm_cable/createCable',
      'm_cable/fetchCables',
      'm_cable/fetchLines',
      'm_cable/updateCable',
      'm_cable/deleteCable',
      'm_cable/fetchNextMaxCode',

      'm_project/fetchProjectVesselNames'
    ]),

    refreshCables() {
      this['m_cable/fetchCables']({
        pId: this.selProjectId,
        vId: this.selVesselId
      })
    },

    refreshLines() {
      this['m_cable/fetchLines']({
        pId: this.selProjectId,
        vId: this.selVesselId
      })
    },

    onProjectChange(value) {
      this.selProjectId = value
      this.refreshCables()
    },

    onVesselChange(value) {
      this.selVesselId = value
      this.refreshCables()
    },

    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId
      this.$log.debug('dlg project change', this.dlgSelProjectId)
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)
      this.refreshNextSeqCode()
    },

    onDlgVesselChange() {
      this.$log.debug('dlg vessel changed', this.editedItem.vesselId)
      if (!this.editedItem.projectId || !this.editedItem.vesselId) {
        return

      }

      this.refreshNextSeqCode()
    },

    refreshNextSeqCode(useDefVal) {
      if (this.editedIndex > -1) {
        return false
      }

      let pId = useDefVal ? this.selProjectId : this.editedItem.projectId
      let vId = useDefVal ? this.selVesselId : this.editedItem.vesselId

      this['m_cable/fetchNextMaxCode']({
        pId: pId,
        vId: vId
      }).then((nextCode) => {
        this.editedItem.cableID = nextCode
        this.$nextTick(() => this.$forceUpdate())
      })
    },

    resetEntity(item) {
      this.dlgSelProjectId = null
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)

      this.defaultItem.projectId = this['m_passet/getSelProjectId']
      this.defaultItem.vesselId = this['m_passet/getSelVesselId']

      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.onDlgProjectChange()
      this.showDialog = true
    },

    createItem() {
      this.resetEntity()

      if (this.defaultItem.projectId != null && this.defaultItem.selVesselId) {
        this.onDlgVesselChange()
      }

      this.refreshNextSeqCode()
      this.editedItem.cableID = this['m_cable/getNextSeqCode']
      this.showDialog = true
    },

    deleteItemConfirm(item) {
      this.resetEntity(item)

      var msg = this.editedItem.isDeleted ? 'warming.unlock' : 'warming.lock'
      this.$confirm(this.$t(msg) + this.$t('nav.cable') + '?', {
        buttonTrueText: this.$t('common.ok'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then(
        (res) =>
          res &&
          this['m_cable/deleteCable'](this.editedItem).then(this.refreshCables)
      )
    },

    close() {
      this.$refs.form.resetValidation()
      this.showDialog = false
    },

    save() {
      if (~this.editedIndex) {
        this['m_cable/updateCable'](this.editedItem).then(this.refreshCables)
      }

      if (!~this.editedIndex) {
        this['m_cable/createCable'](this.editedItem).then(this.refreshCables)
      }

      this.close()
    }
  }
}
</script>

<style>
#cablesTable {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 20px;
  width: auto;
  height: auto;
}
#cablesTable header {
  font-weight: bold;
}
#cablesCard {
  width: auto;
}
</style>